import Answer from "./Pages/Answer/Answer"
import Index from "./Pages/Index/Index"
import Result from "./Pages/Result/Result"



let routes = [
    { path:'/:azmoon_online_id/:theme?/:api_token?/:is_ad?' , element: <Index></Index>},
    { path:'/result' , element: <Result></Result>},
    { path:'/answer' , element: <Answer></Answer>},
]


export default routes

